import React, {useEffect, useRef, useState} from "react";
import styles from "./places-input.module.css";
import {useDebounce} from "use-debounce";
import {useDispatch} from "react-redux";
import {addMessage, setWaitingResponse} from "../../store/stateSlice";
import {updateProfile} from "../../../../api";

const PlacesInput = ({title}) => {
  const input = useRef(null);

  const [searchTerm, setSearchTerm] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [debouncedSearchTerm] = useDebounce(searchTerm, 500);

  const [answered, setAnswered] = useState(false);

  const dispatch = useDispatch();

  const handleChange = () => {
    setSearchTerm(input.current.value);
  };

  useEffect(() => {
    console.log(debouncedSearchTerm);
    if (debouncedSearchTerm) {
      console.log("searcj");
      fetch(`https://back-dev.zodiaq.vip/api/geo/search/${debouncedSearchTerm}`)
        .then((resp) => resp.json())
        .then((locations) => {
          setSearchResults(locations.map((el) => el.address));
        })
        .catch((error) => console.log("Request failed", error));
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchTerm]);

  const handleSkip = () => {
    dispatch(addMessage("Skip"));
    dispatch(setWaitingResponse());
    setSearchTerm(null);
    setSearchResults([]);
    setAnswered(true);
  }

  const handleSelect = (evt) => {
    input.current.value = evt.target.innerText;
    setSearchTerm(null);
    setSearchResults([]);
  };

  const handleOnSend = () => {
    if (input.current.value && searchTerm === null) {
      dispatch(addMessage(input.current.value));
      dispatch(setWaitingResponse());
      setAnswered(true);

      updateProfile({
        land: "tarot-chat",
        step: "step4",
        topicType: "address",
        topic: title,
        answer: {
          address: input.current.value
        }
      })
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleOnSend();
    }
  };

  return (
    <div>
      <p className={styles.input_text}>{title}</p>
      {!answered && (
        <div className={styles.input_container}>
          <input
            ref={input}
            type="text"
            name="place"
            required
            className={styles.input}
            onChange={() => handleChange()}
            onKeyDown={handleEnter}
          />
          <button className={styles.button} onClick={handleOnSend}></button>
          <a href="#" className={styles.link} onClick={handleSkip}>Skip</a>
        </div>
      )}
      {searchResults.length > 0 && (
        <ul className={styles.places_list}>
          {searchResults.map((result, idx) => (
            <li key={idx} onClick={handleSelect}>
              {result}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export { PlacesInput };
